import React from "react";
import classNames from "classnames";
import typography from "../typography.module.scss";
import styles from "./OverviewBanner.module.scss";

export const DefaultInfoItem = ({className, icon, label, value, removeDivider, style, ...props}) => {
    const Icon = icon;
    return (
        <div className={classNames(typography.body14, styles["info-item"], {[styles["divider"]]: !removeDivider}, className)} style={style} {...props}>
            <Icon className={styles["icon"]}/>
            <div title={typeof value === 'string' ? value : ""} className={styles["value"]}>{value}</div>
            <div className={styles["label"]}>{label}</div>
        </div>
    );
};

export default ({children, className, customInfoItemComp = DefaultInfoItem, infoItems, ...props}) => {
    const Item = customInfoItemComp;
    return (
        <div className={classNames(styles["container"], className)} {...props}>
            {infoItems && infoItems.map((item, i) => <Item key={i} icon={item.icon} label={item.label} value={item.value} {...item}/>)}
            {!infoItems && children}
        </div>
    );
};
